import { ElementRef } from '@angular/core';
import { forOwn } from '@sama/micro-dash';
import { setCssProperty } from '../../../cross-team-shared/misc-utils';

// The names of the custom css properties need to match what's in the sass
// version of this file

const sharedProperties = {
  padding: '10px',
  'toolbar-width': '44px',
  'toolbar-height': '33px',
  'scrollbar-width': '17px',
  'border-width': '1px',
  'shape-list-width': '270px',
  'object-list-width': '295px',
  // the format of this one is tricky. It's not a full color, but a string you
  // can use to create a color using `rgb(var(--ursa--default-shape-rgb))`. We
  // do it this way so that in certain places we can introduce translucency:
  // `rgb(var(--ursa--default-shape-rgb), 0.5)`
  'default-shape-rgb': '0, 99, 255',
  'timeline-height': '28px',
  'focused-timeline-height': '63px',
  'split-view-toolbar-height': `40px`,
};
export function setSharedCssProperties(
  elementRef: ElementRef<HTMLElement> | ElementRef<SVGElement>,
) {
  const prefix = '--ursa--';
  forOwn(sharedProperties, (value, key) => {
    setCssProperty(elementRef, prefix + key, value);
  });
}

export function getNumericSharedCssProperty(
  propertyName: keyof typeof sharedProperties,
) {
  return parseInt(getSharedCssProperty(propertyName), 10);
}

export function getSharedCssProperty(
  propertyName: keyof typeof sharedProperties,
) {
  return sharedProperties[propertyName];
}
